import React, { useState, Fragment, useEffect } from 'react';
import styles from './ConTrend.module.css';
import { Row, Col, Card, Tooltip, Space, Spin, Select, message } from 'antd';
import { fetchJsData } from '../../../../api';
import { Line } from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';
import Chart from 'react-google-charts';
import { OpenModal } from './AppModal';

const { Option } = Select;

const ConTrend = () => {
    const [trendData, setTrendData] = useState({
        conRel: '',
        labelRel: '',
        appsRel: '',
        barData: '',
        conRelActMod: '',
        curRelVer: '',
    });
    const [modData, setModData] = useState('');
    const [trendLoad, setTrendLoading] = useState(true);
    const [chngLoad, setChngLoading] = useState(true);
    const [limiter, setLimiter] = useState(12);
    const [submit, setSubmit] = useState(true);
    const [event, setEvent] = useState(false);
    const [relAct, setRelAct] = useState('');

    useEffect(() => {
        // console.log("effect");
        fetchData();
    }, [submit]);

    const chartEvents = [
        {
            eventName: 'select',
            callback: ({ chartWrapper }) => {
                const chart = chartWrapper.getChart();
                const selection = chart.getSelection();
                // alert(JSON.stringify(selection));
                const [selectedItem] = selection;
                if (selection.length === 1 && selectedItem.row != null) {
                    const dataTable = chartWrapper.getDataTable();
                    const { row, column } = selectedItem;
                    // console.log(
                    //   "You selected : " +
                    //     JSON.stringify({
                    //       row,
                    //       column,
                    //       value: dataTable.getValue(row, column),
                    //       lable: dataTable.getValue(selection[0].row, 0),
                    //     })
                    // );
                    if (dataTable.getValue(selectedItem.row, 0)) {
                        setModData(trendData['conRelActMod'].filter((x) => x['release_name'] == dataTable.getValue(selectedItem.row, 0)));
                        setRelAct(dataTable.getValue(selectedItem.row, 0));
                        setEvent(true);
                    }
                    console.log('data - ', dataTable.getValue(selectedItem.row, 0));
                } else {
                    console.log('row is null');
                }
            },
        },
    ];

    const fetchData = async () => {
        setTrendLoading(true);
        // const conRel = await fetchTrend("fetConTrend", limiter);
        const conRel = await fetchJsData({
            type: 'fetch',
            qry: 'fetConTrend',
            preProcess: true,
            preProcFunc: 'conTrendProc',
            firstVal: limiter,
        });
        const conRelActMod = await fetchJsData({
            type: 'fetch',
            qry: 'fetConRelActsMods',
        });
        // console.log("Hi  ", conRelActMod["data"]);
        setTrendData({
            conRel: conRel,
            labelRel: conRel['data']['rel'],
            appsRel: conRel['data']['apps'],
            barData: conRel['data']['barTrend'],
            conRelActMod: conRelActMod['data'],
            conData: conRelActMod,
            curRelVer: conRelActMod['data'].length > 0 ? conRelActMod['data'].reverse()[0]['release_name'] : null,
        });
        setTrendLoading(false);
        setChngLoading(!chngLoad);
    };

    function onChange(value) {
        if (value == '100') {
            message.info(`All Release Selected`);
        } else {
            message.info(`Last ${value} Release Selected`);
        }
        setLimiter(parseInt(value));
        setSubmit(!submit);
    }

    return (
        <div>
            {/* date range filter */}
            <Row type="flex" style={{ margin: '5px', padding: '1px' }}>
                <Col className="gutter-row" span={1}></Col>
                <Col className="gutter-row" span={14}>
                    <Card bordered={false} style={{ height: 70, margin: '1px', padding: '1px' }}>
                        <Tooltip title="Release Filter">
                            <Space>
                                <Select
                                    showSearch
                                    style={{ width: 400 }}
                                    placeholder="Release Filter"
                                    optionFilterProp="children"
                                    onChange={onChange}
                                    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    <Option value="6">last 6 Release</Option>
                                    <Option value="12">last 12 Release</Option>
                                    <Option value="24">last 24 Release</Option>
                                    <Option value="100">All Release</Option>
                                </Select>
                            </Space>
                        </Tooltip>
                    </Card>
                </Col>
            </Row>

            {/* No of Connector Apps */}
            <Row style={{ margin: '5px', padding: '1px' }}>
                <Col className="gutter-row" span={1}></Col>
                <Col className="gutter-row" span={22}>
                    <Card
                        title={'Total Number of App Connectors'}
                        size="small"
                        headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                        bordered={false}
                        style={{ height: 380, margin: '1px', padding: '1px' }}
                    >
                        <div>
                            <Fetch1Line
                                label={trendData['labelRel']}
                                data1={trendData['appsRel']}
                                trendLoad={trendLoad}
                                chngLoad={chngLoad}
                                submit={submit}
                                HeadLabel={['Total Number of App Connectors']}
                            />
                        </div>
                    </Card>
                </Col>
            </Row>

            {/* No of Modified App Connectors */}
            <Row style={{ margin: '5px', padding: '1px' }}>
                <Col className="gutter-row" span={1}></Col>
                <Col className="gutter-row" span={22}>
                    <Card
                        title={'Number of Modified App Connectors'}
                        size="small"
                        headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                        bordered={false}
                        style={{ height: 550, margin: '1px', padding: '1px' }}
                    >
                        <div>
                            <Row>
                                <Col className="gutter-row" span={1}></Col>
                                <Col className="gutter-row" span={23}>
                                    <Chart
                                        width={'100%'}
                                        height={'410px'}
                                        chartType="ColumnChart"
                                        loader={<div className={styles.spinner}>{<Spin size="small" />}</div>}
                                        data={trendData['barData']}
                                        legendToggle
                                        options={{
                                            legend: { position: 'bottom' },
                                            chartArea: {
                                                width: '94%',
                                            },
                                            vAxis: {
                                                format: '#',
                                            },
                                            colors: ['#b7eb8f', '#fffb8f', '#ffa39e'],
                                            // enableInteractivity: true,
                                            isStacked: true,
                                            // is3D: true,
                                        }}
                                        render={({ renderControl, renderChart }) => {
                                            return (
                                                <div>
                                                    <Row>
                                                        <div style={{ width: '100%' }}>{renderControl(() => true)}</div>
                                                    </Row>
                                                    <Row>
                                                        <div style={{ width: '90%' }}>{renderChart()}</div>
                                                    </Row>
                                                </div>
                                            );
                                        }}
                                        controls={[
                                            {
                                                controlType: 'StringFilter',
                                                options: {
                                                    filterColumnIndex: 0,
                                                    matchType: 'any', // 'prefix' | 'exact',
                                                    ui: {
                                                        label: 'Search by release',
                                                    },
                                                },
                                            },
                                            {
                                                controlType: 'NumberRangeFilter',
                                                controlID: 'rel-filter',
                                                options: {
                                                    filterColumnIndex: 2,
                                                    ui: {
                                                        labelStacking: 'vertical',
                                                        label: 'Value Selector:',
                                                        allowTyping: false,
                                                        allowMultiple: false,
                                                    },
                                                },
                                            },
                                        ]}
                                        chartEvents={chartEvents}
                                    />
                                </Col>
                                <Fragment>
                                    <OpenModal
                                        openModal={event}
                                        relAct={relAct}
                                        setEvent={setEvent}
                                        conRelActMod={trendData['conRelActMod']}
                                        modData={{ success: 1, data: modData }}
                                        conData={trendData['conData']}
                                        curRelVer={trendData['curRelVer']}
                                    />
                                </Fragment>
                            </Row>
                        </div>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

const Fetch1Line = (props) => {
    const [lineData, setLineData] = useState([]);
    const [load, setLoading] = useState(true);
    useEffect(() => {
        setLoading(true);
        setLineData({
            trend: props.trendData,
            label: props.label,
            dataSet1: props.data1,
            dataSet2: props.data2,
            head: props.HeadLabel,
        });
        setLoading(false);
        // console.log("hey props ");
    }, [props.chngLoad]);

    return (
        <div style={{ margin: '5px', padding: '1px' }}>
            {load ? (
                <div>
                    <Spin className={styles.spinner} size="small" />
                </div>
            ) : (
                <Card size="small" headStyle={{ backgroundColor: '#FDEEF4', border: 0 }} bordered={false}>
                    <Line
                        height={300}
                        data={{
                            labels: lineData['label'],
                            datasets: [data1(lineData['head'], lineData['dataSet1'], labelL2)],
                        }}
                        options={gradientOpt1}
                    />
                </Card>
            )}
        </div>
    );
};

const data1 = (lineHead, lineData, align) => {
    return {
        label: lineHead,
        fill: false,
        pointStyle: 'circle',
        borderColor: '#00991a',
        borderCapStyle: 'butt',
        display: 'auto',
        borderDash: [],
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: 'rgba(102, 245, 66,0.2)',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(75,192,192,1)',
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 3,
        pointHitRadius: 10,
        data: lineData,
        datalabels: align,
    };
};

const labelL2 = {
    // display: "auto",
    anchor: 'top',
    align: 'end',
    offset: 3,
    // backgroundColor: "#FFF",
    borderRadius: 4,
};

const labelL1 = {
    display: 'auto',
    anchor: 'bottom',
    align: 'start',
    offset: 3,
    // backgroundColor: "#FFF",
    borderRadius: 4,
};

const yAxes = {
    dualYaxes: [
        {
            id: 'A',
            type: 'linear',
            position: 'left',
            ticks: {
                suggestedMin: 0,
                padding: 20,
                fontColor: '#9a9a9a',
            },
            gridLines: {
                drawBorder: false,
                display: false,
            },
        },
        {
            id: 'B',
            type: 'linear',
            position: 'right',
            ticks: {
                padding: 15,
                stepSize: 1,
                max: 4,
                min: 0,
            },
            gridLines: {
                drawBorder: false,
                display: false,
            },
        },
    ],
    singYaxes: [
        {
            ticks: {
                // suggestedMin: 0,
                padding: 20,
                stepSize: 1,
                // fontColor: "#9a9a9a",
                // userCallback(label, index, labels) {
                //   // only show if whole number
                //   if (Math.floor(label) === label) {
                //     return label;
                //   }
                // },
            },
            gridLines: {
                drawBorder: false,
                display: false,
            },
        },
    ],
};

const xAxes = [
    {
        barPercentage: 1.6,
        gridLines: {
            drawBorder: false,
            color: 'rgba(225,78,202,0.1)',
            zeroLineColor: 'transparent',
        },
        ticks: {
            display: true,
            padding: 20,
            fontColor: '#9a9a9a',
        },
    },
];

const toolTip = {
    backgroundColor: '#f5f5f5',
    titleFontColor: '#333',
    bodyFontColor: '#666',
    bodySpacing: 4,
    xPadding: 12,
    mode: 'nearest',
    intersect: 0,
    position: 'nearest',
};

const legend = {
    display: true,
    position: 'bottom',
    labels: {
        usePointStyle: true,
        fontColor: '#333',
    },
};

const layout = {
    padding: {
        top: 20,
    },
};

const gradientOpt1 = {
    scales: {
        yAxes: yAxes['singYaxes'],
        xAxes: xAxes,
    },
    layout: layout,
    tooltips: toolTip,
    responsive: true,
    maintainAspectRatio: false,
    legend: legend,
};

export default ConTrend;
